export default __webpack_public_path__ + "static/media/tile_documents.54ff06cf.jpg";